
    <h3 class="mat-dialog-title">
      VAST Integration
    </h3>
    <mat-dialog-content>
      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" [selectedIndex]="0">
        <mat-tab label="Podcast">
          <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" (selectedTabChange)="onSelectionChange($event)" [selectedIndex]="0">
            <mat-tab label="Generic">
              <div>
                                <textarea #genericTag
                                          title="Pixel tag"
                                          class="mat-input-element textarea-note w-100 mb-1"
                                          [(ngModel)]="genericTemplate"
                                          readonly></textarea>

              </div>

            </mat-tab>
            <mat-tab label="Megaphone">
                <textarea #megaphoneTag
                          title="Pixel tag"
                          class="mat-input-element textarea-note w-100 mb-1"
                          [(ngModel)]="genericTemplate"
                          readonly></textarea>
            </mat-tab>
          </mat-tab-group>
        </mat-tab>
        <textarea #foo
                  title="Pixel tag"
                  class="mat-input-element textarea-note w-100 mb-1"
                  [(ngModel)]="genericTemplate"
                  readonly></textarea>

      </mat-tab-group>
    </mat-dialog-content>
    <mat-dialog-actions class="justify-content-center">
      <button mat-raised-button color="primary" [ngxClipboard]="this.currentLabel === 'Generic' ? genericTag : megaphoneTag" (cbOnSuccess)="onCopyToClipboard()" class="iconed  mb-3 mb-sm-0">
        <i class="fas fa-clipboard"></i>
        <span>Copy to clipboard</span>
      </button>
      <button mat-raised-button color="primary" (click)="openDocs()" class="iconed  mb-3 mb-sm-0">
        <i class="fas fa-external-link"></i>
        <span>API Docs</span>
      </button>
      <button mat-raised-button color="" class="mr-1" [mat-dialog-close]="false">Close</button>
    </mat-dialog-actions>
  